var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:layers-line-duotone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.3195 6.45748C1.9955 5.92815 1.3335 5.66348 1.3335 5.33415C1.3335 5.00481 1.9955 4.74081 3.3195 4.21081L5.1915 3.46215C6.5155 2.93215 7.17816 2.66748 8.00016 2.66748C8.82283 2.66748 9.48483 2.93215 10.8088 3.46215L12.6808 4.21081C14.0048 4.74015 14.6668 5.00481 14.6668 5.33415C14.6668 5.66348 14.0048 5.92748 12.6808 6.45748L10.8088 7.20615C9.48483 7.73681 8.82216 8.00081 8.00016 8.00081C7.1775 8.00081 6.5155 7.73615 5.1915 7.20681L3.32016 6.45681L3.3195 6.45748Z",
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M3.84416 6.66748L3.3195 6.87748C1.9955 7.40681 1.3335 7.67215 1.3335 8.00081C1.3335 8.32948 1.9955 8.59415 3.3195 9.12415L5.1915 9.87281C6.5155 10.4035 7.17816 10.6675 8.00016 10.6675C8.82283 10.6675 9.48483 10.4028 10.8088 9.87348L12.6808 9.12415C14.0048 8.59481 14.6668 8.32948 14.6668 8.00081C14.6668 7.67215 14.0048 7.40748 12.6808 6.87748L12.1562 6.66748M3.84416 9.33415L3.3195 9.54415C1.9955 10.0735 1.3335 10.3388 1.3335 10.6675C1.3335 10.9968 1.9955 11.2608 3.3195 11.7908L5.1915 12.5395C6.5155 13.0701 7.17816 13.3341 8.00016 13.3341C8.82283 13.3341 9.48483 13.0695 10.8088 12.5395L12.6808 11.7908C14.0048 11.2615 14.6668 10.9968 14.6668 10.6675C14.6668 10.3388 14.0048 10.0741 12.6808 9.54415L12.1562 9.33415",
    stroke: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanesIcon);
export default __webpack_public_path__ + "static/media/Planes-icon.372acce60cb5b34491b38f37599cea72.svg";
export { ForwardRef as ReactComponent };